import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Button, DataTable, SubHeading } from "../Components";
import { postAxios } from "../Services/commonService";
import {
  API_ALL_KITE_EXCHANGE_IMPORT,
  API_EXPIRED_INSTRUMENT_LIST,
  API_REMOVE_EXPIRED_INSTRUMENT,
} from "../utils/api/ApiConstant";
import DatePickerCom from "../Components/UI/DatePickerCom";

const ExpireInstrument = () => {
  const queryClient = useQueryClient();
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(50);
  const [selectedIds, setSelectedIds] = useState([]);
  const [dates, setDates] = useState({
    startDate: "",
    endDate: "",
  });
  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
  });

  const {
    isLoading,
    data: expiredData,
    refetch,
  } = useQuery({
    queryKey: ["expiredData", currentPage, recordsPerPage],
    queryFn: async () =>
      await postAxios({
        url: API_EXPIRED_INSTRUMENT_LIST,
        payload: {
          startDate: dates?.startDate,
          endDate: dates?.endDate,
          page: currentPage,
          limit: recordsPerPage,
        },
      }),
  });

  const handleRemove = async () => {
    if (selectedIds?.length > 0) {
      const payload = { ids: selectedIds };

      const res = await postAxios({
        url: API_REMOVE_EXPIRED_INSTRUMENT,
        payload,
      });

      if (res) {
        handleSelectionChange([]);
        refetch();
      }
    }
  };

  const handleSearch = () => {
    if (dates?.startDate !== "" && dates?.endDate !== "") {
      refetch();
    }
  };
  useEffect(() => {
    if (!dates?.startDate && !dates?.endDate) {
      refetch();
    }
  }, [dates]);

  const handleClear = () => {
    setDates({ startDate: "", endDate: "" });
  };
  const handleSelectionChange = useCallback((selected) => {
    setSelectedIds(selected);
  }, []);

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const handleRecordsperPage = useCallback((value) => {
    setRecordsPerPage(value);
  }, []);
  const columns = useMemo(
    () => [
      { accessorKey: "name", header: "Name" },
      { accessorKey: "expiry", header: "Expiry" },
      { accessorKey: "exchange_token", header: "Exch Token" },
      { accessorKey: "instrument_token", header: "Inst. Token" },
      { accessorKey: "tradingsymbol", header: "Trading Symbol" },
      { accessorKey: "strike", header: "Strike" },
      { accessorKey: "instrument_type", header: "Instrument Type" },
    ],
    []
  );

  const fetchData = useCallback(() => {
    if (!expiredData) return { data: [], pages: 0 };
    return { data: expiredData?.data, pages: expiredData?.totalPages };
  }, [expiredData]);

  const handleDateChange = (key, el) => {
    let startDate = dates?.startDate;
    let endDate = dates?.endDate;
    if (key === "startDate") {
      startDate = el;
      if (endDate && startDate > endDate) {
        endDate = new Date(startDate.getTime() + 3 * 24 * 60 * 60 * 1000);
      }
    } else if (key === "endDate") {
      endDate = el;
      if (endDate < startDate) {
        startDate = new Date(endDate.getTime() - 3 * 24 * 60 * 60 * 1000);
      }
    }

    setDates({ startDate, endDate });
  };

  return (
    <>
      <SubHeading subTitle="Remove expire contract" isAddBtn={false} />
      <hr style={{ backgroundColor: "white", margin: "0.5px" }} />

      <div className="my-2 px-2">
        <Button className="btn-success mx-1" onClick={handleRemove}>
          Remove
        </Button>
      </div>
      <div className="d-flex px-2">
        <DatePickerCom
          selected={dates?.startDate}
          onChange={(value) => handleDateChange("startDate", value)}
          placeholderText="Start Date..."
        />
        <DatePickerCom
          selected={dates?.endDate}
          onChange={(value) => handleDateChange("endDate", value)}
          placeholderText="End Date..."
        />
        <Button className="btn-success mx-1" onClick={handleSearch}>
          Search
        </Button>
        <Button className="btn-danger mx-1" onClick={handleClear}>
          Clear
        </Button>
      </div>
      <div className="card-body">
        <DataTable
          columns={columns}
          fetchData={fetchData}
          // onSearchChange={handleSearch}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          onRecordsPerPageChange={handleRecordsperPage}
          recordsPerPage={recordsPerPage}
          isLoading={isLoading}
          isIndexing={false}
          isSearchable={false}
          isPageSize={true}
          isCheckBox={true}
          isPagination={true}
          onSelectionChange={handleSelectionChange}
          handleSearchKey={setIsShow}
        />
      </div>
    </>
  );
};

export default ExpireInstrument;
2;
